import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { setUser } from "../store/userSlice";
import { toast } from "react-toastify";

export default function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  // username and password
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();

  const login = async (e) => {
    e.preventDefault();

    let headersList = {
      Accept: "*/*",
      "Content-Type": "application/json",
    };

    let bodyContent = JSON.stringify({
      Email: username,
      Password: password,
    });

    let response = await fetch("/login", {
      method: "POST",
      body: bodyContent,
      headers: headersList,
    });

    const data = await response.json();

    if (response.ok) {
      dispatch(setUser(true));
      console.log(from);
      navigate(from, { replace: true });
    } else {
      toast.error(data.error);
    }
  };

  return (
    <div className="vh-100 d-flex justify-content-center align-items-center">
      <Form onSubmit={login} className="border border-2 p-4 rounded-2">
        <Form.Group className="mb-3 row" controlId="email">
          <div className="col-3">
            <Form.Label>Email</Form.Label>
          </div>
          <div className="col-9">
            <Form.Control
              type="email"
              placeholder="Please enter your email"
              value={username}
              onChange={(e) => setUserName(e.target.value)}
            />
          </div>
        </Form.Group>

        <Form.Group className="mb-3 row" controlId="password">
          <div className="col-3">
            <Form.Label>Password</Form.Label>
          </div>
          <div className="col-9">
            <Form.Control
              type="password"
              placeholder=" Please enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
        </Form.Group>
        <div className="text-center">
          <div className="my-3">
            <Button type="submit" variant="secondary" className=" btn-sm mt-3">
              Login
            </Button>

            <div className="mt-3">
              <Link to={"/forgot-password"}>Forgotten password</Link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
}
